import { createSlice } from "@reduxjs/toolkit";

const initialNotificationsFiltersModalSlice = { isOpen: false }

const notificationsFiltersModalSlice = createSlice({
    name: 'notifications_filters_modal',
    initialState: initialNotificationsFiltersModalSlice,
    reducers: {
        openModal(state) {
            state.isOpen = true
        },
        closeModal(state) {
            state.isOpen = false
        }
    }
})

export const notificationsFiltersModalActions = notificationsFiltersModalSlice.actions;
export default notificationsFiltersModalSlice